import React from 'react'
import IconError from '../../../assets/error.png'
import IconSuccess from '../../../assets/Checkmark.png'
import IconLoading from '../../../assets/spinner-dots.png'

interface Props {
  title: string
  description?: string
  type: 'error' | 'success' | 'loading'
}

const typeStyles = {
  error: {
    bg: 'bg-[#CE1821]',
    icon: IconError
  },
  success: {
    bg: 'bg-[#1F2531]',
    icon: IconSuccess
  },
  loading: {
    bg: 'bg-[#1F2531]',
    icon: IconLoading
  }
}

export default function StatusToast({ title, description, type }: Props) {
  const { bg, icon } = typeStyles[type]

  return (
    <div className={`fixed bottom-6 right-6 z-50 ${bg} text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3`}>
      <img src={icon} alt={`${type} icon`} className="w-5 h-5 object-contain" />
      <div className="flex-1 flex flex-col gap-0.5">
        <h3 className="text-sm font-semibold leading-[18px]">{title}</h3>
        {description && (
          <p className="text-sm font-normal leading-[18px]">{description}</p>
        )}
      </div>
    </div>
  )
}
